<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashout"
  [header]="ctx.immediateCreditOnly ? 'Crédito inmediato' : 'Nuevo cashout'"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'VES'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType !== 'csv'">
    <div class="form-heading">
      <div class="form-title">Ingresa los siguientes campos de tu cashout</div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="status">ID de la transacción (Opcional)</label>
              <input
                type="number"
                placeholder="Ingresa el ID de la transacción"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="client_id">Cliente asignado</label>
              <p-dropdown
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>

            <div class="form-item" *ngIf="!ctx.immediateCreditOnly">
              <label for="status">Tipo de transacción</label>
              <div class="account-type-picker">
                <div
                  *ngFor="let type of ctx.transactionTypes"
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.transaction_type.value ===
                    type.id
                  "
                  (click)="ctx.setTransactionType(type.id)"
                >
                  {{ type.id }}
                </div>
              </div>
            </div>
            <div class="form-item" *ngIf="ctx.isR4ImmediateCredit">
              <label>Destino del crédito inmediato</label>
              <div class="account-type-picker">
                <div
                  class="accu-type"
                  [class.selected]="ctx.r4CreditDestination === 'phone'"
                  (click)="ctx.setR4CreditDestination('phone')"
                >
                  Teléfono
                </div>
                <div
                  class="accu-type"
                  [class.selected]="ctx.r4CreditDestination === 'account'"
                  (click)="ctx.setR4CreditDestination('account')"
                >
                  Cuenta
                </div>
              </div>
            </div>
            <div class="form-item" *ngIf="ctx.isBankTransferSelected">
              <label for="status">Selecciona el tipo de cuenta</label>
              <div class="account-type-picker">
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.account_type.value ===
                    'Cuenta Corriente'
                  "
                  (click)="ctx.setAccountType('Cuenta Corriente')"
                >
                  Cuenta Corriente
                </div>
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.account_type.value ===
                    'Cuenta de Ahorros'
                  "
                  (click)="ctx.setAccountType('Cuenta de Ahorros')"
                >
                  Cuenta de Ahorros
                </div>
              </div>
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="status">Nombres</label>
              <input
                type="text"
                placeholder="Ingresa los nombres"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Apellidos</label>
              <input
                type="text"
                placeholder="Ingresa los apellidos del recipiente"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Tipo de documento</label>
              <div class="document-picker">
                <div
                  class="docu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.id_type.value === 'V'
                  "
                  (click)="ctx.setDocuType('V')"
                >
                  V
                </div>
                <div
                  class="docu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.id_type.value === 'E'
                  "
                  (click)="ctx.setDocuType('E')"
                >
                  E
                </div>
                <div
                  class="docu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.id_type.value === 'J'
                  "
                  (click)="ctx.setDocuType('J')"
                >
                  J
                </div>
                <div
                  class="docu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.id_type.value === 'P'
                  "
                  (click)="ctx.setDocuType('P')"
                >
                  P
                </div>
              </div>
            </div>

            <div class="form-item">
              <label for="status">Número de documento</label>
              <input
                type="number"
                placeholder="Ingresa el número de documento"
                formControlName="id_number"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="status">Banco</label>
              <p-dropdown
                placeholder="Elige el banco"
                formControlName="company_id"
                [options]="ctx.getBanks()"
                optionLabel="shortname"
                [filter]="true"
                filterBy="shortname"
                (onChange)="ctx.pickBank($event)"
                appendTo="body"
              />
            </div>

            <div class="form-item">
              <label for="status">{{ ctx.accountNumberLabel }}</label>
              <input
                type="tel"
                [placeholder]="
                  ctx.accountNumberLabel === 'Número de cuenta'
                    ? 'Ingresa el número de cuenta'
                    : 'Ingresa el número de teléfono'
                "
                formControlName="account_number"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.isR4ImmediateCredit">
              <label>Concepto</label>
              <input
                type="text"
                maxlength="30"
                placeholder="Hasta 30 caracteres"
                formControlName="description"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Monto</label>
              <input
                type="number"
                placeholder="Ingresa el monto del cashout"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="ctx.newTransactionForm.invalid || ctx.addingTransaction"
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
        #fileInput
      />
      <label class="csv-upload-box" for="cashout_csv_file">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />
        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
